import { ChartContainer } from '@/common/components/ui/chart'
import { ChartData } from '@/common/types/chart.type'
import { cn } from '@/common/utils/cn'
import { Bar, BarChart as BarChartComponent, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts'
import CustomChartTooltip from '../ui/chartTooltip'
import CustomChartLabel from '../ui/chartLabel'
import { EmptyStateMessage } from '../EmptyStateMessage'
import { CustomXAxisTick } from './components/CustomXAxisTick'

export interface BarChartProps {
  chartData: ChartData
  className?: string
}

export const BarChart = ({ chartData, className }: BarChartProps) => {

  return (
    <ChartContainer config={chartData.series_settings} className={cn('min-h-[200px] w-full', className)}>
     {!chartData.data.length ? (
      <EmptyStateMessage />
     ) : (
      <BarChartComponent
        data={chartData.data}
        {...{
          overflow: 'visible',
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis 
          dataKey={chartData.primary.query_identifier} 
          interval={0} 
          height={60} 
          tick={
            <CustomXAxisTick 
              chartFullData={chartData.data} 
              dataKey={chartData.primary.query_identifier} 
            />
          }
        />
        <YAxis />
        <Tooltip content={(props) => (
          <CustomChartTooltip {...props} seriesSettings={chartData.series_settings} />
        )} />
        {Object.values(chartData.series_settings).map(({ query_identifier, color, format_parser }) => {
          return (
            <Bar key={query_identifier} dataKey={query_identifier} style={{ fill: color }}
              label={<CustomChartLabel format_parser={format_parser} />}
            />
          )
        })}
      </BarChartComponent>
     )}
    </ChartContainer>
  )
}
